import apiClient from "../../clients/apiClient";
import API_ENDPOINTS from "../../config/apiEndpointsConfig";

export const createRadiodensityMeasurementEndpoint = async data => {
  const endpoint = API_ENDPOINTS.CREATE_RADIODENSITY_MEASUREMENT();
  try {
    const response = await apiClient.post(endpoint, data);
    return response.data;
  } catch (error) {
    throw new Error(
      `Error creating radiodensity measurement: ${error.message}`
    );
  }
};

export const updateRadiodensityMeasurementEndpoint = async (
  measurementId,
  data
) => {
  const endpoint = API_ENDPOINTS.UPDATE_RADIODENSITY_MEASUREMENT(measurementId);
  try {
    const response = await apiClient.patch(endpoint, data);
    return response.data;
  } catch (error) {
    throw new Error(
      `Error updating radiodensity measurement: ${error.message}`
    );
  }
};

export const deleteRadiodensityMeasurementEndpoint = async measurementId => {
  const endpoint = API_ENDPOINTS.DELETE_RADIODENSITY_MEASUREMENT(measurementId);
  try {
    const response = await apiClient.delete(endpoint);
    return response.data;
  } catch (error) {
    throw new Error(
      `Error deleting radiodensity measurement: ${error.message}`
    );
  }
};
